"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _htmlToReact = require("html-to-react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  body div.dataset-body {\n    clear: both;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents["default"].div(_templateObject());

function Text(props) {
  var label = props.label && props.label.length > 0 ? _react["default"].createElement("strong", null, props.label, ":") : '';
  var parser = new _htmlToReact.Parser();
  var text = props.value ? parser.parse(props.value) : '';
  return _react["default"].createElement(_react["default"].Fragment, null, label, " ", text);
}

var _default = Text;
exports["default"] = _default;